module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewContainer"
  }, [(_vm.dialogVisible) ? _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleTab
    },
    model: {
      value: (_vm.tabsName),
      callback: function($$v) {
        _vm.tabsName = $$v
      },
      expression: "tabsName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "商品管理",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "分类管理",
      "name": "second"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabsName == 'first'),
      expression: "tabsName=='first'"
    }]
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "商品名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.goodsName),
      callback: function($$v) {
        _vm.goodsName = $$v
      },
      expression: "goodsName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("商品管理")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.newShopType == 1),
      expression: "this.newShopType == 1"
    }],
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_vm._v(_vm._s(_vm.resultMsg))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.newShopType == 1),
      expression: "this.newShopType == 1"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.selSpread()
      }
    }
  }, [_vm._v("设置推荐")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditingSort),
      expression: "isEditingSort"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleqxbj()
      }
    }
  }, [_vm._v(" 取消编辑 ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditingSort),
      expression: "isEditingSort"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveSort()
      }
    }
  }, [_vm._v(" 保存排序 ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditingSort),
      expression: "!isEditingSort"
    }],
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.editSort()
      }
    }
  }, [_vm._v(" 编辑排序 ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.showadd()
      }
    }
  }, [_vm._v("新增商品")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.goodListInfo,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "60px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "排序",
      "align": "center",
      "width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isEditingSort) ? _c('el-input', {
          staticStyle: {
            "width": "100%",
            "text-align": "center"
          },
          attrs: {
            "maxlength": "3",
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          model: {
            value: (scope.row.sort),
            callback: function($$v) {
              _vm.$set(scope.row, "sort", $$v)
            },
            expression: "scope.row.sort"
          }
        }) : _c('span', [_vm._v(_vm._s(scope.row.sort))])]
      }
    }], null, false, 3206548770)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center",
      "min-width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.goodsName
          }
        }, [_vm._v("\r\n              " + _vm._s(scope.row.goodsName))])]
      }
    }], null, false, 81482131)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品编码",
      "align": "center",
      "min-width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.goodsCode))])]
      }
    }], null, false, 1826216347)
  }), _vm._v(" "), (this.newShopType == 1) ? _c('el-table-column', {
    attrs: {
      "label": "品牌",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.goodsBrandTypeName
          }
        }, [_vm._v("\r\n            " + _vm._s(scope.row.goodsBrandTypeName))])]
      }
    }], null, false, 2844462899)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品类型",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.commodityTypeName))])]
      }
    }], null, false, 1139114938)
  }), _vm._v(" "), (this.newShopType == 1) ? _c('el-table-column', {
    attrs: {
      "label": "市场价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.marketPrice))])]
      }
    }], null, false, 2972921263)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价格",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.promotionPrice))])]
      }
    }], null, false, 1334827992)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品分类",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.tagName))])]
      }
    }], null, false, 551341979)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "浏览数",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.browseCount))])]
      }
    }], null, false, 2396375739)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "有效时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.permanateName))])]
      }
    }], null, false, 1627713748)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最后操作人",
      "align": "center",
      "width": "110px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.lastEditUserName))])]
      }
    }], null, false, 2140050246)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最后操作时间",
      "align": "center",
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.lastEditTime))])]
      }
    }], null, false, 773741221)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "260px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.editinfo(scope.row, 1)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.onshop(scope.row)
            }
          }
        }, [_c('i', {
          class: scope.row.isOnSale == 0 ? 'el-icon-upload2' : 'el-icon-download'
        }), _vm._v("\r\n              " + _vm._s(scope.row.isOnSale == 0 ? "上架" : "下架") + "\r\n            ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.upordown(1, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v("向上 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.upordown(2, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v("向下 ")])]
      }
    }], null, false, 872101368)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-sizes": [10, 20, 30, 50],
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabsName == 'second'),
      expression: "tabsName=='second'"
    }],
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("分类列表")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 10px 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.handlefl()
      }
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.classificationList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }], null, false, 811300409)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分类名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.tagname))]
      }
    }], null, false, 1479241800)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goodscount))]
      }
    }], null, false, 3627854542)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.endDeletefl(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除 ")]), _vm._v(" "), _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.handlefl(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑 ")])]
      }
    }], null, false, 606405383)
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageflIndex,
      "page-size": 10,
      "total": _vm.totalfl
    },
    on: {
      "current-change": _vm.handlePagination
    }
  })], 1)])], 1) : _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "商品信息",
      "name": "spxx"
    }
  }), _vm._v(" "), (this.newShopType == 2) ? _c('el-tab-pane', {
    attrs: {
      "label": "配置清单",
      "name": "pzqd"
    }
  }) : _vm._e(), _vm._v(" "), (this.newShopType == 2) ? _c('el-tab-pane', {
    attrs: {
      "label": "空间效果",
      "name": "kjxg"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'spxx'),
      expression: "activeName == 'spxx'"
    }],
    staticClass: "main_container",
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formInline,
      "label-width": "120px"
    }
  }, [(this.newShopType == 1) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "商品品牌："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "options": _vm.options,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.pinpai),
      callback: function($$v) {
        _vm.pinpai = $$v
      },
      expression: "pinpai"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "商品类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeProductType
    },
    model: {
      value: (_vm.formInline.commodityTypeId),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "commodityTypeId", $$v)
      },
      expression: "formInline.commodityTypeId"
    }
  }, _vm._l((_vm.commodityType), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.newShopType == 2) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "商品类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formInline.constructionId),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "constructionId", $$v)
      },
      expression: "formInline.constructionId"
    }
  }, _vm._l((_vm.constructionMethod), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "适用面积："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "12vh"
    },
    attrs: {
      "maxlength": "10",
      "placeholder": "最小面积",
      "oninput": "value=value.replace(/[^\\d]/g,'')",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    on: {
      "blur": function($event) {
        _vm.formInline.minimum = $event.target.value
      }
    },
    model: {
      value: (_vm.formInline.minimum),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "minimum", $$v)
      },
      expression: "formInline.minimum"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin": "0 5px"
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "12vh"
    },
    attrs: {
      "maxlength": "10",
      "placeholder": "最大面积",
      "oninput": "value=value.replace(/[^\\d]/g,'')",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    on: {
      "blur": function($event) {
        _vm.formInline.maximum = $event.target.value
      }
    },
    model: {
      value: (_vm.formInline.maximum),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "maximum", $$v)
      },
      expression: "formInline.maximum"
    }
  }), _vm._v(" 平米\r\n          ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "商品编码："
    }
  }, [(_vm.addId) ? _c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "maxlength": "50",
      "placeholder": "请输入商品编码"
    },
    model: {
      value: (_vm.formInline.commodityCode),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "commodityCode", $$v)
      },
      expression: "formInline.commodityCode"
    }
  }) : _c('el-autocomplete', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入商品编码",
      "maxlength": "50",
      "fetch-suggestions": _vm.querySearchAsync,
      "value-key": "goodsCode",
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.formInline.commodityCode),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "commodityCode", $$v)
      },
      expression: "formInline.commodityCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(this.newShopType == 1) ? _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "商品单位："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请选择",
      "disabled": _vm.formInline.commodityTypeId == 2 || _vm.formInline.commodityTypeId == 6
    },
    on: {
      "change": _vm.changedw
    },
    model: {
      value: (_vm.formInline.danweiId),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "danweiId", $$v)
      },
      expression: "formInline.danweiId"
    }
  }, _vm._l((_vm.danwei), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.newShopType == 2) ? _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "商品单位："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formInline.spdanwei),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "spdanwei", $$v)
      },
      expression: "formInline.spdanwei"
    }
  }, _vm._l((_vm.spdanweiArr), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1), _vm._v(" "), (_vm.formInline.spdanwei == 0) ? _c('el-input', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "maxlength": "4",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formInline.zidingyi),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "zidingyi", $$v)
      },
      expression: "formInline.zidingyi"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "商品名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "maxlength": "30",
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.formInline.tradeName),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "tradeName", $$v)
      },
      expression: "formInline.tradeName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(this.newShopType == 1) ? _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "库存(选填)："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入商品库存",
      "maxlength": "9",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.formInline.stock),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "stock", $$v)
      },
      expression: "formInline.stock"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (this.newShopType == 1) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "市场价格："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入商品市场价",
      "maxlength": "9",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.formInline.marketPriceOfCommodities),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "marketPriceOfCommodities", $$v)
      },
      expression: "formInline.marketPriceOfCommodities"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])]), _vm._v("　(选填)\r\n          ")], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "商品描述："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "maxlength": "20",
      "placeholder": "最多可输入20个汉字"
    },
    model: {
      value: (_vm.formInline.describe),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "describe", $$v)
      },
      expression: "formInline.describe"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [(this.newShopType == 1) ? _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "促销价格："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入商品促销价",
      "maxlength": "9",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.formInline.promotionPrice),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "promotionPrice", $$v)
      },
      expression: "formInline.promotionPrice"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1) : _vm._e(), _vm._v(" "), (this.newShopType == 2) ? _c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "商品价格："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入商品价格",
      "maxlength": "9",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.formInline.promotionPrice),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "promotionPrice", $$v)
      },
      expression: "formInline.promotionPrice"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("元")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "分类(选填)："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formInline.spflId),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "spflId", $$v)
      },
      expression: "formInline.spflId"
    }
  }, _vm._l((_vm.spflArr), function(item) {
    return _c('el-option', {
      key: item.tagid,
      attrs: {
        "value": item.tagid,
        "label": item.tagname
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.handlefl()
      }
    }
  }, [_vm._v("添加")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "有效期限："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "daterange",
      "editable": false,
      "picker-options": _vm.pickerOptions,
      "range-separator": "至",
      "value-format": "yyyy-MM-dd",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "disabled": _vm.IsNoLimit == 1
    },
    on: {
      "change": _vm.changetime
    },
    model: {
      value: (_vm.formInline.isPromotionId),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "isPromotionId", $$v)
      },
      expression: "formInline.isPromotionId"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    staticStyle: {
      "margin-left": "10px"
    },
    model: {
      value: (_vm.IsNoLimit),
      callback: function($$v) {
        _vm.IsNoLimit = $$v
      },
      expression: "IsNoLimit"
    }
  }, [_vm._v("长期有效")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "线上购买："
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.formInline.zaixianfukuan),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "zaixianfukuan", $$v)
      },
      expression: "formInline.zaixianfukuan"
    }
  }, [_vm._v("在线付款")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-bottom": "5px"
    },
    attrs: {
      "label": "商品图片："
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.imgarr), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "inline-block",
        "position": "relative",
        "line-height": "normal"
      }
    }, [_c('img', {
      staticStyle: {
        "position": "absolute",
        "right": "6px",
        "top": "-8px",
        "cursor": "pointer",
        "z-index": "9",
        "width": "20px"
      },
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.deleteimg(index, item)
        }
      }
    }), _vm._v(" "), _c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin-right": "15px"
      },
      attrs: {
        "src": item,
        "preview-src-list": _vm.imgarr,
        "fit": "cover"
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isdisabled),
      expression: "isdisabled"
    }],
    staticClass: "avatar-uploader",
    attrs: {
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.CoverImg) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.CoverImg
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("建议尺寸：1200*1200，支持的图片格式：jpg、png；单张图片不大于5M。")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "商品视频："
    }
  }, [(_vm.videoSrc) ? _c('div', {
    staticClass: "videoClass"
  }, [_c('span', {
    staticClass: "previewingVideo",
    on: {
      "click": function($event) {
        return _vm.newSeevideo(_vm.videoSrc)
      }
    }
  }, [(_vm.videoImg) ? _c('img', {
    attrs: {
      "src": _vm.videoImg
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/spfm.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconcontainer"
  }, [_c('img', {
    staticClass: "playIcon",
    attrs: {
      "src": require("../../assets/img/play.png")
    }
  })])]), _vm._v(" "), (_vm.videoSrc) ? _c('img', {
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        return _vm.delvideo()
      }
    }
  }) : _vm._e()]) : _c('el-upload', {
    staticClass: "avatar-uploader-zstp",
    attrs: {
      "action": "",
      "accept": "video/*",
      "before-upload": _vm.handleFile
    }
  }, [(_vm.videoFlag) ? _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.videoUploadPercent,
      "width": 80,
      "height": 80
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("视频格式仅支持: mp4. 视频大小不能超过 50MB !")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "60%"
    },
    attrs: {
      "label": "商品详情：",
      "label-width": "118px"
    }
  }, [_c('wjEditor', {
    attrs: {
      "desc": _vm.content1
    },
    on: {
      "change": _vm.contentChangeOne
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'pzqd'),
      expression: "activeName == 'pzqd'"
    }],
    staticClass: "main_container",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "80%"
    },
    attrs: {
      "label": "配置清单 :"
    }
  }, [_c('wjEditor', {
    attrs: {
      "desc": _vm.content2
    },
    on: {
      "change": _vm.contentChangetWO
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'kjxg'),
      expression: "activeName == 'kjxg'"
    }],
    staticClass: "main_container"
  }, [(this.newShopType == 2) ? _c('el-form', {
    staticClass: "spaceEffect"
  }, [_vm._l((_vm.journalArr), function(item, index) {
    return _c('el-form', {
      key: index,
      staticClass: "dottedLine"
    }, [_c('div', {
      staticClass: "sahnchuDiv"
    }, [_c('p', {
      staticStyle: {
        "color": "#888"
      }
    }, [_vm._v("温馨提示：标签名称长度不超过6个字；图片尺寸建议：1200*745 px 每个标签最多支持15张图片 ")]), _vm._v(" "), _c('el-button', {
      staticClass: "shanBtn",
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.shanchu(index)
        }
      }
    }, [_vm._v("刪除")])], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "标签名称 :"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "type": "textarea",
        "placeholder": "例: 客厅",
        "maxlength": "6"
      },
      model: {
        value: (item.labelName),
        callback: function($$v) {
          _vm.$set(item, "labelName", $$v)
        },
        expression: "item.labelName"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "多图上传 :"
      }
    }, [_c('div', {
      staticClass: "upPictures"
    }, [_vm._l((item.imgs), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "multigraph",
        attrs: {
          "data-img": img
        }
      }, [_c('el-image', {
        staticStyle: {
          "width": "80px",
          "height": "80px"
        },
        attrs: {
          "src": img,
          "preview-src-list": [img]
        },
        on: {
          "click": _vm.handleClickItem
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "chahao",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.deldetail(item, index)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": require("../../assets/img/aicon36.png")
        }
      })])], 1)
    }), _vm._v(" "), (item.imgs.length < 15) ? _c('el-upload', {
      attrs: {
        "action": "",
        "multiple": "",
        "accept": ".png, .jpg,.jpeg",
        "limit": 15,
        "before-upload": function (file) { return _vm.multiGraphUpload(file, item); }
      }
    }, [_c('i', {
      staticClass: "el-icon-plus upBtn"
    })]) : _vm._e()], 2)])], 1)
  }), _vm._v(" "), (_vm.journalArr.length < 6) ? _c('div', {
    staticClass: "primarybtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addJournal()
      }
    }
  }, [_vm._v("添加空间效果")])], 1) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loadingBut
    },
    on: {
      "click": function($event) {
        return _vm.endAddAndEdit()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.shangjiadialog,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.shangjiadialog = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.type == 0 ? "您确定上架此商品么?" : "您确定下价架此商品么?"))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.makesure()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.shangjiadialog = false
      }
    }
  }, [_vm._v("取消")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeVideo
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.flTitle,
      "visible": _vm.isToFl,
      "center": true,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isToFl = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入分类名称，不超过5个字",
      "maxlength": "5"
    },
    model: {
      value: (_vm.flName),
      callback: function($$v) {
        _vm.flName = $$v
      },
      expression: "flName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isToFl = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit()
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": true,
      "title": "请选择店铺",
      "visible": _vm.initdialog,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.initdialog = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "店铺名称："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择店铺"
    },
    on: {
      "change": _vm.handleChangeType
    },
    model: {
      value: (_vm.bbid),
      callback: function($$v) {
        _vm.bbid = $$v
      },
      expression: "bbid"
    }
  }, _vm._l((_vm.options1), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.gonext()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fde7b42!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/commoditymanagement.vue
// module id = 1653
// module chunks = 3